import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MovimentacoesPartService } from 'src/app/services/movimentacoes-part.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { NgxMaskDirective } from 'ngx-mask';


@Component({
    selector: 'app-aporte',
    templateUrl: './aporte.component.html',
    styleUrls: ['./aporte.component.css'],
    imports: [ReactiveFormsModule, NgxMaskDirective, ReactiveFormsModule]
})
export class AporteComponent implements OnInit {

  modalStep: string = 'aporte_1';
  
  form: FormGroup = null;
  isValid: boolean = false;

  loading: boolean = false;

  constructor(private movimentacoesPart: MovimentacoesPartService, private toastr: ToastrService) {
  
    this.form = new FormGroup({
      valor:new FormControl(null,[Validators.required]),
      data: new FormControl(null,[Validators.required])
    });
  
  }

  ngOnInit() {
    this.modalStep = 'aporte_1';
    this.form.reset();
  }

  salvarAporte(): boolean{
        
    let valor = this.form.get('valor').value;
    let data = this.form.get('data').value;

    if(valor < 50){
      alert("O Valor mínimo do aporte é de R$: 50,00");
      this.form.get('valor').setValue("");
      return false;
    }

    if(valor > 3000000){
      alert("O Valor máximo do aporte é R$: 3.000.000,00");
      this.form.get('valor').setValue("");
      return false;
    }

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const dataLimite = new Date(hoje)
    dataLimite.setDate(new Date(hoje).getDate() + 30);
    const dataSelecionada = new Date(data)
    dataSelecionada.setHours(0, 0, 0, 0);

    if (dataSelecionada > dataLimite) {
      const dataLimiteFormatada = new Intl.DateTimeFormat('pt-BR').format(dataLimite);
      alert("A data limite para o vencimento é: " + dataLimiteFormatada);
      this.form.get('data').setValue("");
      return false;
    }

    if (dataSelecionada < hoje) {
      alert("A data de vencimento não pode ser menor que a data atual");
      this.form.get('data').setValue("");
      return false;
    }

    this.loading=true;

    this.movimentacoesPart
    .salvaAporte(valor,data)
    .pipe(
      finalize(() => { this.loading=false })
    )
    .subscribe( 
      (fileData) => {
      this.modalStep = 'aporte_2'
     },
     (error: HttpErrorResponse) => {
        this.toastr.error(error.error.ex);
     }
    ) 
    
    return false;
  }

}
